<script lang="ts">

  import Title from '$shared/atoms/Title/Title.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import AtlasMergePrepLogModel from '$shared/models/AtlasMergePrepLogModel';
  import LogProcessor from './LogProcessor';
  import { ToggleButton } from '$shared/components';

  
  interface Props {
    title?: string;
    logs?: any;
  }

  let { title = '', logs = new AtlasMergePrepLogModel() }: Props = $props();

  const logProcessor = new LogProcessor(logs);
  let showAll = $state(false);
  let priorityLogs = logProcessor.getPriorityLogs();
  let isPriorityLogsEmpty = Object.keys(priorityLogs).length === 0;
  // if showAll or if there are no priority logs
  let logsInScope = $derived(showAll || isPriorityLogsEmpty ? logProcessor.getAllLogs() : priorityLogs);
  let detailLog: Record<string, any[]> | null = $state(null);

  let showToggle = $derived(!(detailLog || isPriorityLogsEmpty));

  const onFilterChange = () => {
    showAll = !showAll;
  };

  const onShowDetails = (sectionName: string, log: any) => {
    detailLog = {};
    detailLog[sectionName] = log.details.map((d) => {
      return {
        subSection: log.msg,
        level: d.status,
        msg: d.check
      };
    });
  };

  const onBack = () => {
    detailLog = null;
  };

  const copyToClipboard = (logs: any[]) => {
    const messages = logs.map((log) => {
      let message = '';
      if (log.resolutionId) {
        message += `ResolutionId: ${log.resolutionId}\n`;
      }
      message += `${log.msg}\n`;
      return message;
    });
    navigator.clipboard.writeText(messages.join('\n\n'));
  };
</script>

<div class="comp-atlas-feedback-popup">
  <div class="header">
    <div class="title"><Title type="h3">{title}</Title></div>
    {#if showToggle}
      <div class="actions">
        <p>Show All Logs</p>
        <ToggleButton checked={showAll} onchange={onFilterChange}></ToggleButton>
      </div>
    {/if}
  </div>

  <div class="modal-body">
    {#each Object.keys(detailLog || logsInScope) as key}
      <section class="log-section">
        <div>
          <div class="section-title">
            {#if detailLog}
              <Icon
                value="icon-arrow-left"
                onclick={() => onBack()}
                type={IconType.Button}
                fontSize="24px"
              ></Icon>
            {:else}
              <Icon
                value="icon-clipboard"
                onclick={() => copyToClipboard(logsInScope[key])}
                type={IconType.Button}
                fontSize="16px"
              ></Icon>
            {/if}
            <h4 class="section-heading">{key}</h4>
          </div>
          {#if detailLog && detailLog[key][0]}
            <h4 class="sub-section-heading">{detailLog[key][0].subSection}</h4>
          {/if}
        </div>
        {#each (detailLog || logsInScope)[key] as log}
          <div class="row">
            {#if ['Warning', 'Warn'].includes(log.level)}
              <div class="icon {log.level.toLowerCase()}">
                <Icon value="light-orange icon-warning"></Icon>
              </div>
            {/if}
            {#if ['Error', 'Failed'].includes(log.level)}
              <div class="icon {log.level.toLowerCase()}">
                <Icon value="red icon-x-circle"></Icon>
              </div>
            {/if}
            <div class="desc {['Error', 'Failed', 'Warning'].includes(log.level) ? '' : 'info'}">
              {log.msg}
            </div>
            {#if log.details?.length > 0}
              <div class="icon">
                <Icon
                  onclick={() => onShowDetails(key, log)}
                  value="icon-chevron-right"
                  type={IconType.Button}
                  fontSize="24px"
                ></Icon>
              </div>
            {/if}
          </div>
        {/each}
      </section>
    {/each}
  </div>
</div>

<style>
  .comp-atlas-feedback-popup {
    padding: 24px;
    overflow: auto;
  }

  .header {
    padding: 0 10px 0 0;
    display: flex;
    align-items: center; /* vertical center */
  }

  .title {
    flex: 0 0 70%;
  }

  .actions {
    flex: 0 0 30%;
    display: flex;
    justify-content: flex-end; /* push toggle button to the right */
  }

  .actions > p {
    margin: 0 10px 0 0;
  }

  .modal-body {
    height: 60vh;
    width: 80vh;
    overflow: scroll;
  }

  .log-section {
    /* max-width: 1200px; */
    margin: 20px auto;
    font-family: sans-serif;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .section-heading {
    margin: 0 10px;
  }

  .sub-section-heading {
    margin-bottom: 15px;
  }

  .row {
    display: flex;
    align-items: center; /* vertically align icons with text */
    border-bottom: 1px solid #ddd;
    padding: 0.5rem 0;
  }

  .row .desc {
    flex: 0 0 90%; /* fixed 80% width */
    word-wrap: break-word;
  }

  .desc.info {
    flex: 0 0 95%; /* fixed 80% width */
  }

  .row .icon {
    flex: 0 0 5%; /* fixed 10% width each */
    text-align: center;
  }
</style>
